/**
 * Created by Mark on 22/04/2017.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants/screens.js';
import Action from '../actions/default.js';
import InternationalizationService from '../services/internationalization-service.js';
import InternationalizationStore from '../store/internationalization-store.js';
class ScreenService {

    getVerbModules(verbUid , packageUid , toIetf){

        return ApplicationServices.call(Constants.GET_VERBS , {verbUid:verbUid,
            packageUid:packageUid,
            toIetf:toIetf}).then(function(response){
            return response;
        }.bind(this))
    }

    getScreenModules(){

        return ApplicationServices.call(Constants.GET_SCREEN_MODULES , {screenUid:100}).then(function(response){
               Action.update(Constants.UPDATE_SCREEN_MODULES , response);
        });
    }

    getModules(screenUid){
        InternationalizationService.getUserTranslations(InternationalizationStore.determineLocaleFromBrowser());
        return ApplicationServices.call(Constants.GET_SCREEN_MODULES , {screenUid:screenUid}).then(function(response){
                return response;
        });
    }

    getMap(curriculumID , learning , support){
        support = InternationalizationStore.determineLocaleFromBrowser();

        return ApplicationServices.call(Constants.GETMAP , {support:support.substring( 0, 2), learning:learning , curriculumID:curriculumID}).then(function(response){
            return response.map;
        });
    }

}

export default new ScreenService();


// WEBPACK FOOTER //
// ./src/services/screens-service.js